import React from "react";
import { Table } from "antd";

const JSLOverallReportTable = ({ tableData, loading }) => {
  const columns = [
    {
      title: "SN",
      dataIndex: "sn",
      key: "sn",
      width: 200,
    },
    {
      title: "Description",
      dataIndex: "sub_lable",
      key: "sub_lable",
      width: 200,
    },
    {
      title: "Data",
      dataIndex: "total",
      key: "total",
      width: 110,
    },
  ];

  return (
    <>
      <Table
        columns={columns}
        dataSource={tableData}
        className="report-table"
        pagination={{ defaultPageSize: 50 }}
        rowKey="uniqueKey"
        size="small"
        scroll={{ y: "60vh" }}
        loading={loading}
      />
    </>
  );
};

export default JSLOverallReportTable;
